/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../../src/app/shared/components/hj-intl-tel-input/hj-intl-tel-input.component';
import * as i2 from '@angular/forms';
const styles_HjIntlTelInputComponent:any[] = ([] as any[]);
export const RenderType_HjIntlTelInputComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_HjIntlTelInputComponent,data:{}});
export function View_HjIntlTelInputComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{phoneElmRef:0}),(_l()(),i0.ɵeld(0,[[1,0],
      ['phoneInput',1]],(null as any),5,'input',[['type','text']],[[8,'className',
      0],[8,'placeholder',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
      [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'ngModelChange'],[(null as any),'blur'],[(null as any),'input'],[(null as any),
      'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i1.HjIntlTelInputComponent = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,2)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,2).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i0.ɵnov(_v,2)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i0.ɵnov(_v,2)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_4:any = ((<any>(_co.value = $event)) !== false);
      ad = (pd_4 && ad);
    }
    if (('blur' === en)) {
      const pd_5:any = ((<any>_co.onInputBlur()) !== false);
      ad = (pd_5 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
      [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(671744,(null as any),0,i2.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,(null as any),0,i2.NgControlStatus,
          [i2.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:i1.HjIntlTelInputComponent = _v.component;
    const currVal_9:any = i0.ɵinlineInterpolate(1,'',_co.name,'');
    const currVal_10:any = _co.value;
    _ck(_v,4,0,currVal_9,currVal_10);
  },(_ck,_v) => {
    var _co:i1.HjIntlTelInputComponent = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.class,'');
    const currVal_1:any = i0.ɵinlineInterpolate(1,'',_co.placeholder,'');
    const currVal_2:any = i0.ɵnov(_v,6).ngClassUntouched;
    const currVal_3:any = i0.ɵnov(_v,6).ngClassTouched;
    const currVal_4:any = i0.ɵnov(_v,6).ngClassPristine;
    const currVal_5:any = i0.ɵnov(_v,6).ngClassDirty;
    const currVal_6:any = i0.ɵnov(_v,6).ngClassValid;
    const currVal_7:any = i0.ɵnov(_v,6).ngClassInvalid;
    const currVal_8:any = i0.ɵnov(_v,6).ngClassPending;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
  });
}
export function View_HjIntlTelInputComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'hj-intl-tel-input',
      ([] as any[]),(null as any),(null as any),(null as any),View_HjIntlTelInputComponent_0,
      RenderType_HjIntlTelInputComponent)),i0.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i1.HjIntlTelInputComponent]),i0.ɵprd(5120,(null as any),i2.NG_VALIDATORS,
      (p0_0:any) => {
        return [p0_0];
      },[i1.HjIntlTelInputComponent]),i0.ɵdid(4374528,(null as any),0,i1.HjIntlTelInputComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const HjIntlTelInputComponentNgFactory:i0.ComponentFactory<i1.HjIntlTelInputComponent> = i0.ɵccf('hj-intl-tel-input',
    i1.HjIntlTelInputComponent,View_HjIntlTelInputComponent_Host_0,{class:'class',
        name:'name',phoneNumber:'phoneNumber',placeholder:'placeholder',separateDialCode:'separateDialCode',
        preferredCountries:'preferredCountries'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9oai1pbnRsLXRlbC1pbnB1dC9oai1pbnRsLXRlbC1pbnB1dC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2hqLWludGwtdGVsLWlucHV0L2hqLWludGwtdGVsLWlucHV0LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9oai1pbnRsLXRlbC1pbnB1dC9oai1pbnRsLXRlbC1pbnB1dC5jb21wb25lbnQudHMuSGpJbnRsVGVsSW5wdXRDb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9oai1pbnRsLXRlbC1pbnB1dC9oai1pbnRsLXRlbC1pbnB1dC5jb21wb25lbnQudHMuSGpJbnRsVGVsSW5wdXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aW5wdXQgdHlwZT1cInRleHRcIiBbKG5nTW9kZWwpXT1cInZhbHVlXCIgbmFtZT1cInt7bmFtZX19XCIgY2xhc3M9XCJ7e2NsYXNzfX1cIiBwbGFjZWhvbGRlcj1cInt7cGxhY2Vob2xkZXJ9fVwiICNwaG9uZUlucHV0ICAoYmx1cik9XCJvbklucHV0Qmx1cigpXCI+IiwiPGhqLWludGwtdGVsLWlucHV0PjwvaGotaW50bC10ZWwtaW5wdXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O3lEQ0FBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO01BQUE7TUFBQTtJQUFBO0lBQW1CO01BQUE7TUFBQTtJQUFBO0lBQWlHO01BQUE7TUFBQTtJQUFBO0lBQXBIO0VBQUEsdUNBQUE7TUFBQTthQUFBO1FBQUE7TUFBQSxvQ0FBQTtVQUFBO1VBQUEsb0RBQUE7dUJBQUEsbUNBQUE7VUFBQTs7SUFBdUM7SUFBcEI7SUFBbkIsV0FBdUMsVUFBcEIsVUFBbkI7OztJQUF1RDtJQUFrQjtJQUF6RTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQXVELFVBQWtCLFVBQXpFO1FBQUEsbUJBQUE7Ozs7b0JDQUE7TUFBQTt3Q0FBQTtNQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7TUFBQSx1Q0FBQTtNQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/shared/components/hj-intl-tel-input/hj-intl-tel-input.component.ngfactory.ts